"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTINGENT_JOB_OFFER_DECISION_STATUSES = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.CONTINGENT_JOB_OFFER_DECISION_STATUSES = (0, lib_custom_types_1.strictUnionArray)()([
    'accept',
    'reject',
]);
